// Import plugin base styles first
import.meta.glob("../../css/index.css", { eager: true });
import.meta.glob("../../../src/Core/Blocks/Content/**/**/style.css", { eager: true });
import.meta.glob("../../../src/Core/Blocks/Marginals/**/**/style.css", { eager: true });

// Theme styles are enqueued separately in Enqueues.php to ensure they load last in the cascade
// This allows theme CSS to override plugin CSS variables and styles

// Plugin base scripts
// Import vendor scripts synchronously (needed for jQuery plugins)
import.meta.glob("../src/vendors/block.js", { eager: true });
import.meta.glob("../src/vendors/foundation.js", { eager: true });
import.meta.glob("../src/vendors/mobile.js", { eager: true });
// Parallax is lazy-loaded only when needed (data-parallax="scroll" elements detected)
import("../src/vendors/parallax-lazy.js");
import.meta.glob("../src/scripts/*", { eager: true });
import.meta.glob("../../../src/Core/Blocks/Content/**/**/script.js", { eager: true });
import.meta.glob("../../../src/Core/Blocks/Marginals/**/**/script.js", { eager: true });

// Theme scripts are imported in their respective files (theme.js, theme-parent.js, theme-child.js)
// This allows proper cascade ordering with CSS
